export default "__VITE_ASSET__CCMdJRzC__"